module.exports = __webpack_public_path__ + "img/escriba-vagas.94ed48ab.png";